/**
 * The "Branch Manager" block as the forms hold it, plus the client-side mirror
 * of the API's rules. Shared by the create page and the edit modal so the two
 * can never drift apart — the API validates the same shape for both.
 */

/** What a brand-new branch form starts with: a manager has to be chosen. */
export const EMPTY_MANAGER = {
  managerMode: "existing",
  userId: "",
  newManager: { name: "", email: "", password: "", passwordConfirmation: "" },
};

/**
 * Editing an existing branch starts here instead: "unchanged" sends no manager
 * fields at all, which is how the API is told to keep whoever runs the branch
 * today. Without it, every edit of a phone number would have to re-answer the
 * manager question — and a branch with nobody assigned could not be saved.
 */
export const KEEP_MANAGER = { ...EMPTY_MANAGER, managerMode: "unchanged" };

/** Mirrors the API's manager rules so an obvious slip costs no round trip. */
export const validateManager = (manager, t) => {
  if (manager.managerMode === "unchanged") return {};

  if (manager.managerMode === "existing") {
    return manager.userId ? {} : { user_id: [t("branchForm.manager.errors.pick")] };
  }

  const { name, email, password, passwordConfirmation } = manager.newManager;
  const found = {};

  if (name.trim().length < 2) found["new_manager.name"] = [t("branchForm.manager.errors.name")];
  if (!/^\S+@\S+\.\S+$/.test(email.trim())) {
    found["new_manager.email"] = [t("branchForm.manager.errors.email")];
  }
  if (password.length < 8) {
    found["new_manager.password"] = [t("branchForm.manager.errors.password")];
  } else if (password !== passwordConfirmation) {
    found["new_manager.password"] = [t("branchForm.manager.errors.passwordConfirm")];
  }

  return found;
};

/** The API error keys this block owns, in the order the fields are rendered. */
export const MANAGER_FIELD_IDS = {
  user_id: "managerUserId",
  "new_manager.name": "managerName",
  "new_manager.email": "managerEmail",
  "new_manager.password": "managerPassword",
};
